"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// TODO: We need to find a way to explicitly reference the AUI webcomponent rather than implicitly depending on it from the AUI global js.
//if (typeof window !== 'undefined') {
//    require('@atlassian/aui/lib/js/aui/drop-down');
//    require('@atlassian/aui/lib/js/aui/dropdown2');
//}

var AUIDropdownMenu = function AUIDropdownMenu(_ref) {
    var children = _ref.children,
        otherProps = _objectWithoutProperties(_ref, ["children"]);

    return _react2.default.createElement(
        "div",
        _extends({}, otherProps, { className: "aui-dropdown2 aui-style-default" }),
        children
    );
};

AUIDropdownMenu.displayName = "AUIDropdownMenu";
exports.default = AUIDropdownMenu;
//# sourceMappingURL=AUIDropdownMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIDropdownMenu.js
// module id = 182
// module chunks = 0